import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as navegacaoActions from './actions/navegacaoActions'
import ConfigD from './util/ConfigD';
import $ from 'jquery';

import './css/mainBody.css'

class MainBody extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state ={
            objNavegacao: {
              natureza: !$.isEmptyObject(this.props.params) && this.props.params.natureza ? this.props.params.natureza : 'geral',
              uf: !$.isEmptyObject(this.props.params) && this.props.params.uf ? this.props.params.uf:'',
              canal: !$.isEmptyObject(this.props.params) && this.props.params.canal ? this.props.params.canal : 'portal',
              grupoTratamento: !$.isEmptyObject(this.props.params) && this.props.params.grupo ? this.props.params.grupo : 'ouvidoria'
            },
            linkCadastro:'',
            linkCadastrodenuncia:''
          }
  
        
        this.hrefCadastrarProtocolo = this.hrefCadastrarProtocolo.bind(this);
        this.hrefCadastrarDenuncia = this.hrefCadastrarDenuncia.bind(this);
        this.hrefConsultarManifestacao = this.hrefConsultarManifestacao.bind(this);

    }
    hrefCadastrarProtocolo() {
       
       var linkCadastro = '/portal/ouvidoria/geral/';
 
       if(!$.isEmptyObject(this.props.navegacao)){
            linkCadastro = '/' + this.props.navegacao.canal + '/' + this.props.navegacao.grupoTratamento + '/'+ this.props.navegacao.natureza+'/'+ this.props.navegacao.uf;
        }
       this.context.router.push(ConfigD.getServerBase() + '/cadastrarProtocolo' + linkCadastro);
        //window.location.replace('/');
    }

    hrefCadastrarDenuncia(){

        var linkCadastrodenuncia = '/portal/ouvidoria/denuncia';
  
        if(!$.isEmptyObject(this.props.navegacao)){
              linkCadastrodenuncia = '/' + this.props.navegacao.canal + '/ouvidoria/denuncia';
        }
         this.context.router.push(ConfigD.getServerBase() + '/cadastrarProtocolo' + linkCadastrodenuncia);
    }

    hrefConsultarManifestacao(){
        this.context.router.push(ConfigD.getServerBase() + '/consultarProtocolo');
        
    }

    componentDidMount() {
        window.UIinitJS.initIndex();
        var objNavegacao = {
            natureza: !$.isEmptyObject(this.props.params) && this.props.params.natureza ? this.props.params.natureza : 'geral',
            uf: !$.isEmptyObject(this.props.params) && this.props.params.uf ? this.props.params.uf:'',
            canal: !$.isEmptyObject(this.props.params) && this.props.params.canal ? this.props.params.canal : 'portal',
            grupoTratamento: !$.isEmptyObject(this.props.params) && this.props.params.grupo ? this.props.params.grupo : 'ouvidoria'
          }
  
          if ($.isEmptyObject(this.props.navegacao)) {
            this.props.actionsNavegacao.ArmazenaNavegacao(objNavegacao)
          }
    }

        
    componentWillReceiveProps(nextProps) {
        var linkCadastro = '';
        var linkCadastrodenuncia = '';

        
        if(!$.isEmptyObject(this.props.navegacao)){
            linkCadastro = '/' + this.props.navegacao.canal + '/' + this.props.navegacao.grupoTratamento + '/' + this.props.navegacao.natureza + '/' + this.props.navegacao.uf ;
            linkCadastrodenuncia = '/' + this.props.navegacao.canal + '/' + this.props.navegacao.grupoTratamento  + '/denuncia';
            this.setState({linkCadastro:linkCadastro, linkCadastrodenuncia:linkCadastrodenuncia});
        }
        else{
             linkCadastro = '/' + this.state.objNavegacao.canal + '/' + this.state.objNavegacao.grupoTratamento + '/' + this.state.objNavegacao.natureza;
             linkCadastrodenuncia = '/' + this.state.objNavegacao.canal + '/' + this.state.objNavegacao.grupoTratamento  + '/denuncia';
             this.setState({linkCadastro:linkCadastro, linkCadastrodenuncia:linkCadastrodenuncia});
             this.props.actionsNavegacao.ArmazenaNavegacao(null);
            }
    }

    render() {

        var linkCadastro = '/portal/ouvidoria/geral/';
        var linkCadastrodenuncia = '/portal/ouvidoria/denuncia';
  
        if(!$.isEmptyObject(this.props.navegacao)){
          linkCadastro = '/' + this.props.navegacao.canal + '/' + this.props.navegacao.grupoTratamento + '/'+ this.props.navegacao.natureza+'/'+ this.props.navegacao.uf;
          linkCadastrodenuncia = '/' + this.props.navegacao.canal + '/ouvidoria/denuncia';
       }
  
        
        return (
            <div id="main">
                <div className="fullwidthbanner-container">
                    <div className="fullwidthbanner rslider">
                        <ul>
                            <li data-transition="fade" data-slotamount="7" data-masterspeed="500" data-saveperformance="on">
                                <img src={ConfigD.getServerBase() + '/img/slider/1920x400_Ouvidoria_v1.jpg'} alt="Pixma" data-lazyload={ConfigD.getServerBase() + '/img/slider/1920x400_Ouvidoria_v1.jpg'} data-bgposition="center top" data-bgfit="cover" data-bgrepeat="no-repeat" />

                                <div className="caption modern_big_bluebg h1 lft tp-caption start"
                                    data-x="40"
                                    data-y="85"
                                    data-speed="700"
                                    data-endspeed="800"
                                    data-start="1000"
                                    data-easing="easeOutQuint"
                                    data-endeasing="easeOutQuint">
                                    <h3>Registre sua manifestação.</h3>
                                </div>
                                <div className="caption list_slide lfb tp-caption start"
                                    data-easing="easeOutExpo"
                                    data-start="1400"
                                    data-speed="1050"
                                    data-y="180"
                                    data-x="40">
                                    <div className="list-slide">
                                        <i className="fa fa-bullhorn slide-icon"></i>
                                        <h5 className="big_black"> Reclamação </h5>
                                    </div>
                                </div>
                                <div className="caption list_slide lfb tp-caption start"
                                    data-easing="easeOutExpo"
                                    data-start="1800"
                                    data-speed="1200"
                                    data-y="220"
                                    data-x="40">
                                    <div className="list-slide">
                                        <i className="fa fa-comment-o slide-icon"></i>
                                        <h5 className="big_black"> Sugestão </h5>
                                    </div>
                                </div>
                                <div className="caption list_slide lfb tp-caption start"
                                    data-easing="easeOutExpo"
                                    data-start="2200"
                                    data-speed="1350"
                                    data-y="260"
                                    data-x="40">
                                    <div className="list-slide">
                                        <i className="fa fa-check slide-icon"></i>
                                        <h5 className="big_black"> Elogio </h5>
                                    </div>
                                </div>
                                <div className="caption list_slide lfb tp-caption start"
                                    data-easing="easeOutExpo"
                                    data-start="2600"
                                    data-speed="1350"
                                    data-y="300"
                                    data-x="40">
                                    <div className="list-slide">
                                        <i className="fa fa-lock slide-icon"></i>
                                        <h5 className="big_black"> Denúncia </h5>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                    <div className="container">
                        <div className="row">
                            <div className="slogan-content col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                                    <h2 className="">A Ouvidoria Sebrae irá acolher e tratar a sua manifestação, com o sigilo necessário, tomando as devidas providências para que a sua questão seja avaliada, no prazo especificado.
No caso de denúncia, seu tratamento tem um caminho próprio e especial no SEBRAE para garantir a integridade da nossa atuação.
Imediatamente após cadastrar a sua manifestação você receberá um número que permitirá acompanhar o andamento da sua demanda aqui no site.
</h2>
                                </div>
                                 <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                                 <br/>
                                    <div className="get-started">
                                    <button className="btn btn-special btn-color btn-main" onClick={this.hrefCadastrarProtocolo} >Faça sua reclamação, sugestão ou elogio</button><br/>
                                    <button className="btn btn-special btn-Denuncia btn-main" onClick={this.hrefCadastrarDenuncia} >Faça sua denúncia</button>
                                    <button className="btn btn-special btn-Consultar btn-main" onClick={this.hrefConsultarManifestacao} >Consulte sua manifestação</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <br />
        </div>

        );
    }
}


MainBody.protoType = {
    //actionCliente: PropTypes.object.isRequired
    actions: PropTypes.object.isRequired
  
  }
  MainBody.contextTypes = {
    router: React.PropTypes.object
  };
  
  function mapStateToProps(state, ownProps){
    
    return {
        navegacao: state.navegacao
    };
  }
  
  function mapDispatchToProps(dispatch){
   return {
    actionsNavegacao: bindActionCreators(navegacaoActions, dispatch),
    };
    
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(MainBody);


/** WEBPACK FOOTER **
 ** ./src/components/MainBody.js
 **/